import { routerHelpers } from '@approvalmax/utils';
import { selectors } from 'modules/common';
import { backend, domain } from 'modules/data';
import { integrationActions } from 'modules/integration';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { routingService } from 'services/routing';
import { useInvalidateGetCompanies } from 'shared/data/webApp/v1';
import { useInvalidateGetCompanies as useInvalidateGetCompaniesV2 } from 'shared/data/webApp/v2';
import { useCompanyIdBasedOnUrl, useCreateOrganisation } from 'shared/hooks';
import { getPath, Path } from 'urlBuilder';

const useSignInWithStartFinalizeQboPageData = () => {
    const dispatch = useDispatch();
    const search = useLocation().search;
    const code = routerHelpers.getParamAsString(search, 'code', '');
    const state = routerHelpers.getParamAsString(search, 'state', '');
    const realmId = routerHelpers.getParamAsString(search, 'realmId', '');
    const { companyId } = useCompanyIdBasedOnUrl();

    const invalidateGetCompanies = useInvalidateGetCompanies();
    const invalidateGetCompaniesV2 = useInvalidateGetCompaniesV2();
    const createOrganisation = useCreateOrganisation();

    const invalidateSelectCompanyQuery = useCallback(() => {
        invalidateGetCompaniesV2();
        invalidateGetCompanies({ query: { companyId } });
    }, [companyId, invalidateGetCompanies, invalidateGetCompaniesV2]);

    let integration = useSelector(selectors.integration.getIntegrations).find((x) => x.integratedCompanyId === realmId);

    useEffect(() => {
        const loadData = async () => {
            if (integration && integration.status === domain.IntegrationStatus.Connected) {
                // 1. realmId is already connected, no action is required2
                routingService.replaceToDefaultPath();

                return;
            }

            let companyId;

            if (integration) {
                // 2. Company found!
                companyId = integration.companyId;
            }

            let newCompany = false;

            if (!companyId) {
                const companyCreatedInfo: unknown = await createOrganisation(domain.IntegrationType.QBooks);

                newCompany = true;

                if (!companyCreatedInfo) {
                    routingService.replaceToDefaultPath();

                    return;
                }

                companyId = (companyCreatedInfo as backend.CompanyCreatedInfo | null)?.CompanyId;
            }

            if (companyId) {
                dispatch(
                    integrationActions.completeIntegrationAuth(
                        {
                            newCompany,
                            integrationType: domain.IntegrationType.QBooks,
                            code,
                            state,
                            companyId,
                            realmId,
                        },
                        invalidateSelectCompanyQuery
                    )
                );
                routingService.replace(getPath(Path.companyWorkflows, companyId));
            } else {
                routingService.replaceToDefaultPath();
            }

            return;
        };

        loadData();
    }, [code, createOrganisation, dispatch, integration, invalidateSelectCompanyQuery, realmId, state]);
};

export default useSignInWithStartFinalizeQboPageData;
